import { LoadState } from "../../../constants/enums";

export interface IAddressHistoryState {
  list: IAddressHistory[];
  addressHistory: IAddressHistory;
  loading: LoadState;
  error: string | null;
}

export interface IAddressHistory {
  customer_policy_id: number | null;
  customer_id: number | null;
  incremental_number: number | null;
  address_type: string | null;
  address: string | null;
  unit_of_suite: string | null;
  province_or_state: string | null;
  city: string | null;
  postal_code: string | null;
  country: string | null;
  date_moved_in: string;
  date_moved_out: string;
  status: string | null;
}

export const INITIAL_ADDRESS_HISTORY: IAddressHistory = {
    customer_policy_id: null,
    customer_id: null,
    incremental_number: null,
    address_type: null,
    address: null,
    unit_of_suite: null,
    province_or_state: null,
    city: null,
    postal_code: null,
    country: null,
    date_moved_in: "",
    date_moved_out: "",
    status: "ACTIVE" ,
  }

export const initialAddressHistoryState: IAddressHistoryState = {
  list: [],
  addressHistory: INITIAL_ADDRESS_HISTORY,
  loading: LoadState.NotLoaded,
  error: null,
};
